import AjioOwn from './NewAjioOwnCollectionContainerComponent';
import BrandWeLove from './NewBrandWeLoveComponent';
import DIOTwoImage from './NewDIOTwoImageComponent';
import HotBrands from './NewHotBrandsComponent';
import IndieCollection from './NewIndieCollectionContainerComponent';
import InternationalBrands from './NewInternationalBrandComponent';
import NativeCarousel210x196 from './NativeCarousel210x196';
import NativeCarousel270x70 from './NativeCarousel270x70';
import NativeFeatureHeroGridCarousel from './NativeFeatureHeroGridCarousel';
import NativeGrid106x54 from './NativeGrid106x54';
import NativeSpacing320x16 from './NativeSpacing320x16';
import NativeFeatureHeroListCarousel from './NativeFeatureHeroListCarousel';
import NewTitle from './NewTitleComponent';
import OfferCollection from './NewOfferCollectionContainerComponent';
import OffersOverlap from './NewOfferOverlapComponent';
import OwnTheLook from './NewOwnTheLookComponent';
import RotatingImagesComponent from '../../common/banner/RotatingImagesComponent';
import Trending from './NewTrendingComponent';
import VimeoVideoCustomComponent from './VimeoVideoCustomComponent';
import WomenBanner from './WomenBannerComponent';
import NativeHeroGrid719X514 from './NativeHeroGrid719X514';
import NativeFeatureOverlapCarouselList from './NativeFeatureOverlapCarouselList';
import NativeFeatureHeroGrid from './NativeFeatureHeroGrid';
import VideoAndImageComponent from './VideoAndImageComponent';

const TYPE_CODES = {
  NewTitleComponent: 'NewTitleComponent',
  WomenBannerComponent: 'WomenBannerComponent',
  NewTrendingComponent: 'NewTrendingComponent',
  NewOwnTheLookComponent: 'NewOwnTheLookComponent',
  NewBrandWeLoveComponent: 'NewBrandWeLoveComponent',
  NewDIOTwoImageComponent: 'NewDIOTwoImageComponent',
  NewIndieCollectionContainerComponent: 'NewIndieCollectionContainerComponent',
  NewInternationalBrandComponent: 'NewInternationalBrandComponent',
  NewAjioOwnCollectionContainerComponent: 'NewAjioOwnCollectionContainerComponent',
  NewOfferCollectionContainerComponent: 'NewOfferCollectionContainerComponent',
  NewHotBrandsComponent: 'NewHotBrandsComponent',
  NewOfferOverlapComponent: 'NewOfferOverlapComponent',
  NativeCarousel210x196: 'NativeCarousel210x196',
  NativeCarousel270x70: 'NativeCarousel270x70',
  NativeFeatureHeroGridCarousel: 'NativeFeatureHeroGridCarousel',
  NativeGrid106x54: 'NativeGrid106x54',
  NativeSpacing320x16: 'NativeSpacing320x16',
  NativeFeatureHeroListCarousel: 'NativeFeatureHeroListCarousel',
  VimeoVideoCustomComponent: 'VimeoVideoCustomComponent',
  RotatingImagesComponent: 'RotatingImagesComponent',
  NativeHeroGrid719X514: 'NativeHeroGrid719X514',
  NativeFeatureOverlapCarouselList: 'NativeFeatureOverlapCarouselList',
  NativeFeatureHeroGrid: 'NativeFeatureHeroGrid',
  VideoAndImage: 'VideoAndImage'
};

export const BannerComponentJSON = {
  [TYPE_CODES.NewTitleComponent]: {
    componentClassName: 'title-com',
    Component: NewTitle
  },

  [TYPE_CODES.NewTrendingComponent]: {
    componentClassName: 'trending',
    Component: Trending,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.WomenBannerComponent]: {
    componentClassName: 'women-banner',
    Component: WomenBanner,
    gtmBannerEventEnabled: true,
    bannerProperty: 'banner'
  },
  [TYPE_CODES.NewOwnTheLookComponent]: {
    componentClassName: 'ownlook',
    Component: OwnTheLook,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NewBrandWeLoveComponent]: {
    componentClassName: 'brandlove',
    Component: BrandWeLove,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NewDIOTwoImageComponent]: {
    componentClassName: 'diotwo-image',
    Component: DIOTwoImage,
    gtmBannerEventEnabled: true,
    bannerProperty: 'leftBanner'
  },
  [TYPE_CODES.NewIndieCollectionContainerComponent]: {
    componentClassName: 'indiecollection',
    Component: IndieCollection,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NewInternationalBrandComponent]: {
    componentClassName: 'inbrand',
    Component: InternationalBrands,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NewAjioOwnCollectionContainerComponent]: {
    componentClassName: 'ajioown',
    Component: AjioOwn,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NewOfferCollectionContainerComponent]: {
    componentClassName: 'offer-collection',
    Component: OfferCollection,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NewHotBrandsComponent]: {
    componentClassName: 'hotbrands',
    Component: HotBrands,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NewOfferOverlapComponent]: {
    componentClassName: 'offer-overlap',
    Component: OffersOverlap,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NativeCarousel210x196]: {
    componentClassName: 'nativecarousel210x196',
    Component: NativeCarousel210x196,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NativeCarousel270x70]: {
    componentClassName: 'nativecarousel270x70',
    Component: NativeCarousel270x70,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NativeFeatureHeroGridCarousel]: {
    componentClassName: 'herogrid-carousel',
    Component: NativeFeatureHeroGridCarousel,
    offsetVertical: 250,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NativeGrid106x54]: {
    componentClassName: 'NativeGrid106x54',
    Component: NativeGrid106x54,
    gtmBannerEventEnabled: true,
    bannerProperty: 'leftBanner'
  },
  [TYPE_CODES.NativeSpacing320x16]: {
    componentClassName: '',
    Component: NativeSpacing320x16
  },
  [TYPE_CODES.NativeFeatureHeroListCarousel]: {
    componentClassName: 'herolist-carousel',
    Component: NativeFeatureHeroListCarousel
  },
  [TYPE_CODES.VimeoVideoCustomComponent]: {
    componentClassName: 'video-comp',
    Component: VimeoVideoCustomComponent
  },
  [TYPE_CODES.RotatingImagesComponent]: {
    componentClassName: 'rotated-image-component',
    Component: RotatingImagesComponent,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NativeHeroGrid719X514]: {
    componentClassName: 'NativeHeroGrid719X514',
    Component: NativeHeroGrid719X514,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.NativeFeatureOverlapCarouselList]: {
    componentClassName: 'feature-overlapcomp',
    Component: NativeFeatureOverlapCarouselList
  },
  [TYPE_CODES.NativeFeatureHeroGrid]: {
    componentClassName: 'herogrid',
    Component: NativeFeatureHeroGrid,
    gtmBannerEventEnabled: true,
    bannerProperty: 'bannerImageDetails'
  },
  [TYPE_CODES.VideoAndImage]: {
    Component: VideoAndImageComponent
  }
};
